module.exports = __webpack_public_path__ + "static/group-168-f66f24d2da2188a51f3a8d8809aea399.svg";